<template>
  <section>
    <ChooseTmpl
      ref="chooseTmpl"
      title="选择导流罩"
      :resultVal="resultVal"
      :isRadio="isRadio"
      :otherSearchData="otherSearchData"
      :searchBoxDataTmpl="searchBoxDataTmpl"
      :getListApi="getListApi"
      :tableTitle="tableTitle"
      :tableSelectTar="tableSelectTar"
      :showTableTitle="showTableTitle"
      @change="handleResultChange"
      :handleSearchData="handleSearchData"
      :customShow="customShow"
      :showName="showName"
      :clearable="clearable"
    >
      <section slot="tableSlot" slot-scope="scope">
        <section v-if="scope.column.property === 'certificatesInsuranceFee'">
          <span>{{scope.row[scope.column.property] / 100}}</span>
        </section>
        <section v-else>{{scope.row[scope.column.property]}}</section>
      </section>
    </ChooseTmpl>
  </section>
</template>

<script>
import {
  gpsList,
} from 'api/cost';
import ChooseTmpl from 'components/choose/tmpl/tmpl.vue';
export default {
  components: {
    ChooseTmpl,
  },
  model: {
    prop: 'resultVal', // 父级传进来的值
    event: 'change',
  },
  props: {
    clearable: { // 清除按钮
      type: Boolean,
      default: false,
    },
    resultVal: {
      default: '',
    },
    isRadio: {
      type: Boolean,
      default: false,
    },
    otherSearchData: {
      type: Object,
      default: () => ({}),
    },
    customShow: { // 是否自定义展示结果
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      showName: 'plateNumber',
      tableSelectTar: 'id',
      searchBoxDataTmpl: {
        form: [
          { // 安装时间
            label: '安装时间',
            value: 'installDate',
            type: 'date',
            default: [],
            placeholder: '请选择安装时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
        ],
      },
      showTableTitle: [
        {
          prop: 'plateNumber',
          label: '车牌号码',
        },
        {
          prop: 'licenceTypeName',
          label: '证照类型',
        },
      ],
      tableTitle: [
        {
          prop: 'plateNumber',
          label: '车牌号',
        },
        {
          prop: 'installDate',
          label: '安装时间',
        },
        {
          prop: 'purchaseFeeDouble',
          label: '采购金额',
        },
      ],
    };
  },
  methods: {
    getListApi: gpsList,
    handleResultChange (val) {
      this.$emit('change', val);
    },
    handleSearchData (searchBoxData) {
      if (searchBoxData.installDate[0]) {
        searchBoxData.installDateBegin = this.formatDate(searchBoxData.installDate[0], 1);
        searchBoxData.installDateEnd = this.formatDate(searchBoxData.installDate[1], 1);
      }
      delete searchBoxData.violationTime;
      return searchBoxData;
    },
    show () {
      this.$refs.chooseTmpl.show();
    },
  },
};
</script>

<style>

</style>
